import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { removeCaracter } from 'src/app/core/constants/properties-const';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent {

  public removeCaracter = removeCaracter;
  public title = 'Documentação';
  selectedOptions = [
    {name: 'Lorem ipsum dolor 1' },
    {name: 'Lorem ipsum dolor 2' },
    {name: 'Lorem ipsum dolor 3' }
  ];


}